import { Controller } from "@hotwired/stimulus"

// Loader stays visible until the page is actually ready (CSS + JS; Stripe on signup).
// No minimum display time — hide as soon as ready, whether that is instant or slow.
export default class extends Controller {
  static values = {
    requirePageReady: { type: Boolean, default: false },
    autostart: { type: Boolean, default: true },
  }

  connect() {
    this.pageReady = !this.requirePageReadyValue

    this.onShow = () => this.show()
    this.onHide = () => this.hide()
    this.onPageReady = () => {
      this.pageReady = true
      this.tryHide()
    }
    this.onReadyStateChange = () => this.tryHide()

    this.onLoad = () => this.tryHide()

    document.addEventListener("auth-loader:show", this.onShow)
    document.addEventListener("auth-loader:hide", this.onHide)
    document.addEventListener("auth-loader:ready", this.onPageReady)
    document.addEventListener("readystatechange", this.onReadyStateChange)
    window.addEventListener("load", this.onLoad)

    if (document.body.classList.contains("auth-page-ready")) {
      this.hide()
    } else if (this.autostartValue) {
      this.show()
      this.tryHide()
    } else {
      this.hide()
    }
  }

  disconnect() {
    document.removeEventListener("auth-loader:show", this.onShow)
    document.removeEventListener("auth-loader:hide", this.onHide)
    document.removeEventListener("auth-loader:ready", this.onPageReady)
    document.removeEventListener("readystatechange", this.onReadyStateChange)
    window.removeEventListener("load", this.onLoad)
  }

  show() {
    document.body.classList.remove("auth-page-ready")
    document.body.classList.add("auth-submitting")
    this.element.classList.remove("auth-loader--hidden")
    this.element.setAttribute("aria-busy", "true")
  }

  hide() {
    this.element.classList.add("auth-loader--hidden")
    this.element.setAttribute("aria-busy", "false")
    document.body.classList.remove("auth-submitting")
    document.body.classList.add("auth-page-ready")
  }

  tryHide() {
    if (!this.documentReady()) return
    if (this.requirePageReadyValue && !this.pageReady) return
    this.hide()
  }

  documentReady() {
    return document.readyState === "complete"
  }
}
